import {
  HighlightCard,
  HighlightCardContent,
  ReviewText,
  ReviewerInfo,
} from './Endorsements.styles';

function EndorsementHighlight({ endorsement, fullReview = false }) {
  return (
    <HighlightCard>
      <HighlightCardContent>
        <ReviewText paragraph variant="h6">
          &ldquo;{fullReview ? endorsement.review : endorsement.highlight}
          &rdquo;
        </ReviewText>
        {fullReview ? null : (
          <ReviewerInfo align="right" variant="subtitle1">
            -{endorsement.reviewer}: {endorsement.relation}
          </ReviewerInfo>
        )}
      </HighlightCardContent>
    </HighlightCard>
  );
}

export default EndorsementHighlight;
